import { COLUMN_MIN_WIDTH, GRID_ROWS } from "./constants";

/**
 * `layoutCount` lets callers size the grid for the largest tab (e.g. production area)
 * rather than the currently visible `sites`, so switching tabs doesn't resize the panel.
 */
export function getSiteColumns<T>(
  sites: T[],
  availableWidth: number,
  layoutCount: number = sites.length
): T[][] {
  const count = Math.max(sites.length, layoutCount);
  const maxColumns = Math.max(1, Math.floor(availableWidth / COLUMN_MIN_WIDTH));
  const rows = Math.max(GRID_ROWS, Math.ceil(count / maxColumns));
  const columnCount = Math.max(1, Math.ceil(count / rows));
  const columns: T[][] = Array.from({ length: columnCount }, () => []);

  sites.forEach((site, index) => {
    columns[Math.floor(index / rows)].push(site);
  });

  return columns;
}
